module.exports = __webpack_public_path__ + "img/diminished-value-protection.e679ddd7.jpg";